import React from "react";

const CommonTextField = ({ value, onChange, label, id, placeholder, isInvalid,required }) => {

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <div className="w-full">
      <label htmlFor={id} className="text-gray-800 text-sm font-medium">
        {label} {required &&<span className="text-red-500">*</span>}
      </label>
      <textarea
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        className={`flex min-h-[50px] w-full rounded-lg border ${
          isInvalid
            ? "border-red-500 shadow-md shadow-red-400/20"
            : "border-gray-300"
        } bg-white px-4 py-2 text-sm focus:outline-none focus:shadow-md focus:border-brand-500 focus:shadow-brand-500/30 resize-y`}
      />
    </div>
  );
};

export default CommonTextField;
